import {Component, OnDestroy} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive} from '@angular/router';
import {NgIconComponent, provideIcons} from '@ng-icons/core';
import {heroCalendarDays, heroCog6Tooth, heroHome, heroListBullet, heroMap, heroBars3} from '@ng-icons/heroicons/outline';
import {heroMapPinSolid} from '@ng-icons/heroicons/solid';
import {NgClass} from '@angular/common';
import {Subscription} from 'rxjs';
import {PlatformService} from '../../../shared/platform.service';
import {Dialog} from '@angular/cdk/dialog';
import {MenuComponent} from '../menu/menu.component';

@Component({
  selector: 'app-navigation',
  standalone: true,
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [
    RouterLink,
    NgIconComponent,
    RouterLinkActive,
    NgClass
  ],
  viewProviders: [provideIcons({heroHome, heroMap, heroCalendarDays, heroListBullet, heroCog6Tooth, heroMapPinSolid, heroBars3})]
})
export class NavigationComponent implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  isMap = true;
  isAndroid = false;

  constructor(private _router: Router, private _platformService: PlatformService, private _dialog: Dialog) {
    const subscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isMap = event.url === '/kaart';
      }
    });
    this._subscriptions.push(subscription);
    this.isAndroid = this._platformService.isAndroid();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected openMenu() {
    this._dialog.open(MenuComponent, {
      panelClass: 'menu-dialog-panel',
      backdropClass: 'menu-dialog-backdrop',
      disableClose: true,
    });
  }
}
